import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin JWT if present
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("void_admin_token");
  if (t && cfg.url && cfg.url.startsWith("/admin")) {
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export async function getCounter() {
  const { data } = await api.get("/counter");
  return data;
}

export async function prepareMessage(message, category) {
  const { data } = await api.post("/messages/prepare", {
    message,
    category,
    origin_url: window.location.origin,
  });
  return data;
}

export async function getPaymentStatus(session_id) {
  const { data } = await api.get(`/payments/status/${session_id}`);
  return data;
}

export async function adminLogin(email, password) {
  const { data } = await api.post("/admin/login", { email, password });
  return data;
}

export async function adminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}

export async function adminRecent() {
  const { data } = await api.get("/admin/recent");
  return data;
}
